import { render } from "./Design.vue?vue&type=template&id=7da3ec9c"
import script from "./Design.vue?vue&type=script&lang=js"
export * from "./Design.vue?vue&type=script&lang=js"

import "./Design.vue?vue&type=style&index=0&id=7da3ec9c&lang=scss"

import exportComponent from "C:\\Users\\PC\\Documents\\RWI\\surefooted-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__